import React from "react";
import {
  FiCalendar,
  FiClock,
  FiUser,
  FiCheck,
  FiXCircle,
} from "react-icons/fi";

const STATUS_CONFIG = {
  // ===== PENDING / CONFIRMATION =====
  "pending vendor confirmation": {
    bg: "bg-pendingAmber",
    text: "text-pendingAmber",
    icon: <FiUser className="text-white" size={18} />,
  },
  "pending user confirmation": {
    bg: "bg-pendingAmber",
    text: "text-pendingAmber",
    icon: <FiUser className="text-white" size={18} />,
  },
  "awaiting user confirmation": {
    bg: "bg-pendingAmber",
    text: "text-pendingAmber",
    icon: <FiUser className="text-white" size={18} />,
  },
  pending: {
    bg: "bg-pendingAmber",
    text: "text-pendingAmber",
    icon: <FiClock className="text-white" size={18} />,
  },

  // ===== UPCOMING / ONGOING =====
  upcoming: {
    bg: "bg-upcomingBlue",
    text: "text-upcomingBlue",
    icon: <FiCalendar className="text-white" size={18} />,
  },
  ongoing: {
    bg: "bg-upcomingBlue",
    text: "text-upcomingBlue",
    icon: <FiClock className="text-white" size={18} />,
  },
  "vendor proposed alternate time": {
    bg: "bg-upcomingBlue",
    text: "text-upcomingBlue",
    icon: <FiCalendar className="text-white" size={18} />,
  },

  // ===== COMPLETED =====
  completed: {
    bg: "bg-successGreen",
    text: "text-successGreen",
    icon: <FiCheck className="text-white" size={18} />,
  },
  "vendor completed": {
    bg: "bg-successGreen",
    text: "text-successGreen",
    icon: <FiCheck className="text-white" size={18} />,
  },

  // ===== CANCEL / DENIED =====
  cancelled: {
    bg: "bg-errorRed",
    text: "text-errorRed",
    icon: <FiXCircle className="text-white" size={18} />,
  },
  "canceled by user": {
    bg: "bg-errorRed",
    text: "text-errorRed",
    icon: <FiXCircle className="text-white" size={18} />,
  },
  "denied by vendor": {
    bg: "bg-errorRed",
    text: "text-errorRed",
    icon: <FiXCircle className="text-white" size={18} />,
  },
  "denied by user": {
    bg: "bg-errorRed",
    text: "text-errorRed",
    icon: <FiXCircle className="text-white" size={18} />,
  },

  // ===== NO SHOW =====
  "no show": {
    bg: "bg-disabledGray",
    text: "text-disabledGray",
    icon: <FiXCircle className="text-white" size={18} />,
  },
};

export default function BookingStatusTimeline({ title, timeline = [] }) {
  return (
    <div>
      {title && <h2 className="text-lg font-semibold mb-6">{title}</h2>}

      <div className="space-y-0">
        {timeline.map((item, index) => {
          const isLast = index === timeline.length - 1;
          const key = item.status?.toLowerCase();
          const config = STATUS_CONFIG[key] || STATUS_CONFIG["pending"]; // fallback safe

          return (
            <div key={index} className="flex gap-4">
              {/* LEFT ICON + CONNECTOR */}
              <div className="flex flex-col items-center">
                <div
                  className={`h-9 w-9 rounded-full flex items-center justify-center ${config.bg}`}
                >
                  {config.icon}
                </div>

                {!isLast && (
                  <svg
                    width="6"
                    height="36"
                    viewBox="0 0 6 36"
                    className="my-1"
                  >
                    <line
                      x1="3"
                      y1="0"
                      x2="3"
                      y2="36"
                      stroke="currentColor"
                      className={config.text}
                      strokeWidth="1"
                      strokeDasharray="4 6"
                      strokeLinecap="round"
                    />
                  </svg>
                )}
              </div>

              {/* RIGHT TEXT */}
              <div className="pb-6">
                <p className={`font-medium text-[15px] ${config.text}`}>
                  {item.status}
                </p>

                {item.timestamp && (
                  <p className="text-xs text-gray-400 mt-1">{item.timestamp}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
